module.exports = "/_next/static/images/flag-logo-4f7c94893e3bdb990ae1aa069940cf73.png";